import React, { useState, useEffect } from 'react';
import { Mail, Plus, Trash2, Pencil } from 'lucide-react';
import api from '../services/api';

const emptyForm = { funcionario_id:'', ativo:true, nome:'', destino:'', gatilho:'fichas_retidas', periodo_dias:15 };

export default function EmailRegras() {
    const [regras, setRegras] = useState([]);
    const [funcionarios, setFuncionarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState({...emptyForm});
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState('');

    const carregar = async () => {
        try {
            const r = await api.get('/api/email-regras');
            setRegras(r.data);
            const f = await api.get('/api/funcionarios');
            setFuncionarios(f.data);
        } catch (e) { setErro('Falha ao carregar: ' + (e.response?.data?.erro || e.message)); }
    };
    useEffect(() => { carregar(); }, []);

    const abrirNovo = () => { setForm({...emptyForm}); setEditId(null); setErro(''); setShowModal(true); };
    const abrirEdit = (r) => { setForm({ funcionario_id:r.funcionario_id, ativo:r.ativo, nome:r.nome, destino:r.destino, gatilho:r.gatilho, periodo_dias:r.periodo_dias }); setEditId(r.id); setErro(''); setShowModal(true); };

    const salvar = async () => {
        setErro('');
        if (!form.funcionario_id) { setErro('Escolha o agente.'); return; }
        if (!form.nome.trim()) { setErro('Nome da regra obrigatorio.'); return; }
        if (!form.destino.trim()) { setErro('E-mail de destino obrigatorio.'); return; }
        setSalvando(true);
        try {
            if (editId) await api.put('/api/email-regras/' + editId, form);
            else await api.post('/api/email-regras', form);
            setShowModal(false); carregar();
        } catch (e) { setErro(e.response?.data?.erro || e.message); }
        finally { setSalvando(false); }
    };

    const apagar = async (id) => {
        if (!window.confirm('Apagar esta regra de e-mail?')) return;
        try { await api.delete('/api/email-regras/' + id); carregar(); }
        catch (e) { setErro(e.response?.data?.erro || e.message); }
    };

    const nomeFunc = (id) => { const f = funcionarios.find(x => x.id === id); return f ? f.nome : '(agente removido)'; };

    return (
        <div style={{padding:'24px', color:'#fff'}}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
                <h1 style={{display:'flex', alignItems:'center', gap:'10px', fontSize:'22px'}}><Mail size={22}/> Regras de E-mail</h1>
                <button onClick={abrirNovo} style={{display:'flex', alignItems:'center', gap:'6px', background:'#6c5ce7', border:'none', borderRadius:'8px', padding:'10px 16px', color:'#fff', cursor:'pointer', fontWeight:600}}><Plus size={16}/> Nova regra</button>
            </div>
            {erro && <div style={{background:'#3a1a1a', border:'1px solid #f87171', color:'#f87171', padding:'10px', borderRadius:'8px', marginBottom:'16px'}}>{erro}</div>}

            <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                {regras.length === 0 && <div style={{color:'#8b8fa3'}}>Nenhuma regra de e-mail cadastrada.</div>}
                {regras.map(r => (
                    <div key={r.id} style={{background:'#141625', border:'1px solid #23263a', borderRadius:'10px', padding:'14px 16px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                        <div>
                            <div style={{fontWeight:600, marginBottom:'4px'}}>{r.nome} {!r.ativo && <span style={{color:'#8b8fa3', fontWeight:400}}>(inativa)</span>}</div>
                            <div style={{fontSize:'13px', color:'#8b8fa3'}}>Agente: {nomeFunc(r.funcionario_id)} &middot; Destino: {r.destino} &middot; A cada {r.periodo_dias} dia(s)</div>
                        </div>
                        <div style={{display:'flex', gap:'10px'}}>
                            <button onClick={()=>abrirEdit(r)} style={{background:'transparent', border:'none', color:'#6c5ce7', cursor:'pointer'}}><Pencil size={16}/></button>
                            <button onClick={()=>apagar(r.id)} style={{background:'transparent', border:'none', color:'#f87171', cursor:'pointer'}}><Trash2 size={16}/></button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100}}>
                    <div style={{background:'#0d0f1a', border:'1px solid #23263a', borderRadius:'12px', padding:'24px', width:'520px', maxWidth:'92vw', maxHeight:'90vh', overflowY:'auto'}}>
                        <h2 style={{marginBottom:'16px'}}>{editId ? 'Editar regra' : 'Nova regra de e-mail'}</h2>
                        {erro && <div style={{background:'#3a1a1a', border:'1px solid #f87171', color:'#f87171', padding:'8px', borderRadius:'6px', marginBottom:'12px'}}>{erro}</div>}

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Agente</label>
                        <select value={form.funcionario_id} onChange={e=>setForm({...form, funcionario_id:e.target.value})}
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'14px', boxSizing:'border-box'}}>
                            <option value="">Selecione...</option>
                            {funcionarios.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                        </select>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Nome da regra</label>
                        <input value={form.nome} onChange={e=>setForm({...form, nome:e.target.value})} placeholder="Ex: Cadastros retidos SulAmerica"
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'14px', boxSizing:'border-box'}}/>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>E-mail de destino</label>
                        <input value={form.destino} onChange={e=>setForm({...form, destino:e.target.value})} placeholder="destino@empresa.com"
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'14px', boxSizing:'border-box'}}/>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Gatilho</label>
                        <select value={form.gatilho} onChange={e=>setForm({...form, gatilho:e.target.value})}
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'14px', boxSizing:'border-box'}}>
                            <option value="fichas_retidas">Resumo periodico das fichas retidas</option>
                        </select>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Periodo (dias)</label>
                        <input type="number" min="1" value={form.periodo_dias} onChange={e=>setForm({...form, periodo_dias:parseInt(e.target.value,10)||1})}
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'14px', boxSizing:'border-box'}}/>

                        <label style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'20px', cursor:'pointer'}}>
                            <input type="checkbox" checked={form.ativo} onChange={e=>setForm({...form, ativo:e.target.checked})}/>
                            Regra ativa
                        </label>

                        <div style={{display:'flex', justifyContent:'flex-end', gap:'10px'}}>
                            <button onClick={()=>setShowModal(false)} style={{background:'transparent', border:'1px solid #23263a', borderRadius:'8px', padding:'10px 16px', color:'#c8cbe0', cursor:'pointer'}}>Cancelar</button>
                            <button onClick={salvar} disabled={salvando} style={{background:'#6c5ce7', border:'none', borderRadius:'8px', padding:'10px 20px', color:'#fff', cursor:'pointer', fontWeight:600}}>{salvando ? 'Salvando...' : 'Salvar'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
